import React from 'react';

const RouteContext = React.createContext({});
const RouteContextProvider = RouteContext.Provider;
const RouteContextConsumer = RouteContext.Consumer;

export { RouteContext, RouteContextProvider, RouteContextConsumer };
